import React from 'react';
import { Field } from 'redux-form';
import { BooleanInput, LongTextInput, TextField } from 'react-admin';
import { required } from 'react-admin';
import { FormDataConsumer } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import CanViewCreativeCode from '../Helpers/CanViewCreativeCode';
import ConfirmDestroy from '../../../../Common/Buttons/ConfirmDestroy';

const ValidateRequired = required();

const styles = createStyles({
  name: {
    width: '80%'
  }
});

type Props = {
  classes: any,
  index: number,
  item: string,
  record: any
};

const CreativeSettingsHome = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        <FormDataConsumer>
          {({ formData, ...rest }) => CanViewCreativeCode(formData, props.index) &&
            <span>ID: <TextField source={`${props.item}.code`} record={props.record} style={{ display: 'inline' }} /><br /></span>
          }
        </FormDataConsumer>
        <Field name={`${props.item}.active`} source={`${props.item}.active`} component={BooleanInput} label="Active" style={{ width: '0' }} />
      </div>
      <div style={{ flex: 1 }}>
        <FormDataConsumer>
          {({ formData, ...rest }) => CanViewCreativeCode(formData, props.index) &&
            <br />
          }
        </FormDataConsumer>
        <Field name={`${props.item}.display_multiple`} source={`${props.item}.display_multiple`} component={BooleanInput} label="Display Multiple Times" style={{ display: 'inline' }} /><br />
      </div>
    </div>
    <Field name={`${props.item}.name`} source={`${props.item}.name`} component={LongTextInput} label="Name *" validate={ValidateRequired} className={props.classes.name} />
    <div style={{ display: 'inline' }}>
      <Field name={`${props.item}._destroy`} source={`${props.item}._destroy`} component={ConfirmDestroy} />
    </div>
  </div>
);

export default withStyles(styles)(CreativeSettingsHome);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/CreativeSettingsHome.tsx